import qs from 'querystring';
import { PlatformType, getAppVersion, getPlatformType } from '@nibfe/mkt-env-api';
const isWeb = true;
const isMRN = false;
import { navigateTo } from '@max/meituan-uni-navigate';
export const parseCityName = (cityName) => {
    const MAX_CITY_NAME_LENGTH = 3;
    return cityName.length > MAX_CITY_NAME_LENGTH ? cityName.slice(0, MAX_CITY_NAME_LENGTH - 1) + '...' : cityName;
};
export const parsePrice = (ticketPrice) => {
    const priceArray = ticketPrice.split('.');
    if (priceArray.length === 2 && parseInt(priceArray[1]) === 0) {
        return priceArray[0];
    }
    return ticketPrice;
};
export const parseImageUrl = (imageUrl) => {
    const url = imageUrl.replace(/^https?:/, '');
    if (isSupportWebp()) {
        return url + '.webp';
    }
    return url;
};
export const compareVersion = (v1, v2) => {
    const arr1 = v1.split('.');
    const arr2 = v2.split('.');
    const len = Math.max(arr1.length, arr2.length);
    while (arr1.length < len) {
        arr1.push('0');
    }
    while (arr2.length < len) {
        arr2.push('0');
    }
    for (let i = 0; i < len; i++) {
        const num1 = parseInt(arr1[i]);
        const num2 = parseInt(arr2[i]);
        if (num1 > num2) {
            return 1;
        }
        else if (num1 < num2) {
            return 0;
        }
    }
    return 1;
};
export const getMTTrainListURL = (city) => {
    const webURL = 'https://i.meituan.com/awp/h5/train/list/list.html';
    const appVersion = getAppVersion();
    if (appVersion && compareVersion(appVersion, '12.2.200')) {
        return getNewMTJumpUrl(city);
    }
    else {
        let q = getQueryParams(city);
        let querystring;
        if (appVersion && compareVersion(appVersion, '7.4')) {
            querystring = qs.stringify(q);
            return `imeituan://www.meituan.com/train/train_list?${querystring}&isActivity=true`;
        }
        q.hidden_nav_bar = 2;
        querystring = qs.stringify(q);
        return `imeituan://www.meituan.com/train/hybrid/web?url=${encodeURIComponent(`${webURL}?${querystring}`)}`;
    }
};
const getDPTrainListURL = (city) => {
    const platform = getPlatformType();
    const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView].includes(platform);
    const appVersion = getAppVersion();
    if (isDp && appVersion && compareVersion(appVersion, '10.62.0')) {
        return getNewDPJumpUrl(city);
    }
    else {
        const q = getQueryParams(city);
        const APP_CALL_URL = 'https://m.dianping.com/cube/evoke/meituan.html?url=imeituan%3A%2F%2Fwww.meituan.com%2Ftrain%2Ftrain_list%3FisActivity%3Dtrue';
        return APP_CALL_URL + encodeURIComponent(`&${qs.stringify(q)}`);
    }
};
function isSupportWebp() {
    if (isWeb) {
        return Boolean(document.cookie.match('webp=1')) || localStorage && localStorage.webp === '1';
    }
    else {
        return false;
    }
}
export const isDebug = () => {
    if (true) {
        const origin = window.location.origin;
        return origin.indexOf(':333') >= 0 || origin.indexOf(':334') >= 0;
    }
    return false;
};
export const onHotCityRouteClick = (city) => {
    let url = '';
    const platform = getPlatformType();
    const isMt = [PlatformType.mtApp, PlatformType.mtAppWebView].includes(platform);
    const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView].includes(platform);
    if (isMt) {
        url = getMTTrainListURL(city);
    }
    else {
        url = getDPTrainListURL(city);
    }
    navigateTo({
        url
    });
};
export function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
export function format(date, formatStr) {
    const yyyy = date.getFullYear();
    // 月份需补零，getMonth() 返回 0-11
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    if (formatStr === 'YYYY-MM-DD') {
        return `${yyyy}-${mm}-${dd}`;
    }
    return '';
}
const getNewMTJumpUrl = (city) => {
    const trafficPageParams = {
        isCRH: false,
        isStudent: false,
        departureDate: format(addDays(new Date(), 1), 'YYYY-MM-DD'),
        departurePlace: {
            stationName: city.fromStationName,
            stationCode: city.fromStationCode,
            isCity: true
        },
        arrivalPlace: {
            stationName: city.toStationName,
            stationCode: city.toStationCode,
            isCity: true
        }
    };
    const rootUrl = 'imeituan://www.meituan.com/traffic/mrn?mrn_biz=train&mrn_entry=train-max-page-list&mrn_component=TrainMaxPageList&trafficPageParams=';
    return rootUrl + encodeURIComponent(JSON.stringify(trafficPageParams));
};
export const getNewDPJumpUrl = (city) => {
    const newDate = format(addDays(new Date(), 1), 'YYYY-MM-DD');
    const listPath = encodeURIComponent(`/pages/list/index?pagefrom=search&fromNative=true&trainType='0'` + `&from_station_name=${city.fromStationName || ''}&from_station_telecode=${city.fromStationCode || ''}&to_station_name=${city.toStationName || ''}&to_station_telecode=${city.toStationCode || ''}&start_date=${newDate}`);
    const DP_NEW_URL = 'dianping://mmp?appId=train-miniprogram&shareEnv=release&targetPath=';
    return DP_NEW_URL + listPath;
};
const getQueryParams = (cityRoute) => {
    const query = {};
    query.startdate = format(addDays(new Date(), 1), 'YYYY-MM-DD');
    query.tocode = cityRoute.toStationCode;
    query.toname = cityRoute.toStationName;
    query.fromcode = cityRoute.fromStationCode;
    query.fromname = cityRoute.fromStationName;
    query.isFromCity = query.isToCity = 0;
    query.jump_to_h5_disabled = 1;
    return query;
};
